import { Component, Input } from '@angular/core';
import { NgClass, NgIf, SlicePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pt-w-measure-category-type-badge',
  standalone: true,
  template: `
    <ng-container *ngIf="type">
      <ng-container *ngIf="typeLabel; then label; else enumLabel"></ng-container>

      <ng-template #label>
        <div container="body"
             [ngbTooltip]="typeLabel!"
             class='dataType'
             [ngClass]="'dataType-' + typeLabel!.toUpperCase()">
          {{ typeLabel! | slice: 0 : 3 }}
        </div>
      </ng-template>

      <ng-template #enumLabel>
        <div container="body"
             [ngbTooltip]="('ENUMS.'+type  | translate)"
             class='dataType'
             [ngClass]="'dataType-' + type?.toUpperCase()">
          {{ 'ENUMS.' + type  | translate | slice: 0 : 3 }}
        </div>
      </ng-template>

    </ng-container>

  `,
  imports: [
    NgIf,
    SlicePipe,
    TranslateModule,
    NgbTooltip,
    NgClass
  ],
  styles: [`
    .dataType {
      width: fit-content;
      border: 1px solid red;
      color: red;
      margin-right: 5px;
      padding: 0 3px;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      font-size: 11px;
      cursor: default;
    }
    .dataType-ORGANIZATIONAL {
      border-color: #0a58ca;
      color: #0a58ca;
    }
    .dataType-TECHNICAL {
      border-color: #22a218;
      color: #22A218;
    }

  `]
})
export class WMeasureCategoryTypeBadgeComponent {
  @Input() type?: string;
  @Input() typeLabel?: string;
}
